"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
var _sanitizer = require("../../../utils/sanitizer");
var _menu = require("../../../utils/menu");
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ExpandableMenuGroup = ({
  node,
  level,
  isActive,
  isExpanded,
  history,
  activeNodePathLength,
  children
}) => {
  var _getVisibleMenuNodes, _node$meta;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const hasInnerNode = Boolean((_getVisibleMenuNodes = (0, _menu.getVisibleMenuNodes)(node === null || node === void 0 ? void 0 : node.children)) === null || _getVisibleMenuNodes === void 0 ? void 0 : _getVisibleMenuNodes.length);
  const isHighlighted = isActive && level === activeNodePathLength;
  const showSubmenu = (0, _react.useCallback)(() => {
    if (isExpanded) {
      var _getVisibleMenuNodes2;
      if ((_getVisibleMenuNodes2 = (0, _menu.getVisibleMenuNodes)(node.children)) !== null && _getVisibleMenuNodes2 !== void 0 && _getVisibleMenuNodes2.length) {
        setIsOpen(true);
      }
    }
  }, [isExpanded, node.children]);
  const hideSubmenu = (0, _react.useCallback)(() => {
    setIsOpen(false);
  }, []);
  (0, _react.useEffect)(() => {
    if (!isExpanded) {
      setIsOpen(false);
    }
  }, [isExpanded]);
  (0, _react.useEffect)(() => {
    if (isActive && !isHighlighted) {
      showSubmenu();
    }
  }, [showSubmenu, isActive, isHighlighted]);
  const sanitizedUri = (0, _react.useMemo)(() => (0, _sanitizer.sanitizeHref)(node.uri), [node.uri]);
  if (node !== null && node !== void 0 && (_node$meta = node.meta) !== null && _node$meta !== void 0 && _node$meta.appframeMenuHide) return null;
  return _react.default.createElement(_styles.ExpandableMenuGroupContainer, null, _react.default.createElement(_MenuItem.default, {
    isActive: isHighlighted,
    title: node.label,
    iconUri: node.icon,
    level: level,
    link: sanitizedUri,
    linkMeta: node.meta,
    isExpanded: isExpanded,
    hasInnerNode: hasInnerNode,
    onArrowIndicatorClick: () => isOpen ? hideSubmenu() : showSubmenu(),
    history: history,
    isOpen: isOpen,
    isExpandable: true,
    isPartOfActivePath: isActive
  }), isOpen && children(node.children, level));
};
var _default = exports.default = ExpandableMenuGroup;